/** @format */

import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import VegaPageContent from './VegaPageContent';

type Props = {
  text?: string;
  subtext?: string;
  image?: React.ReactNode;
  sx?: SxProps<Theme>;
};

const NoResults = ({ text, subtext, image, sx }: Props) => {
  return (
    <VegaPageContent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'white',
        borderRadius: '9px',
        m: 2,
        ...sx,
      }}
    >
      {image && <Box sx={{ marginBottom: 5 }}>{image}</Box>}
      <Typography color={'primary.main'} variant="subtitle1" mb={1}>
        {text || 'No Results'}
      </Typography>
      {subtext && (
        <Typography color={'primary.main'} variant="body2">
          {subtext}
        </Typography>
      )}
    </VegaPageContent>
  );
};

export default NoResults;
